/**
 * Platform utility functions for formatting platform displays
 */

/**
 * Format platform display using platform IDs and platform store data
 * @param platformIds Array of platform IDs (providerPlatformId values)
 * @param platforms Platform store data
 * @param maxPlatforms Maximum number of platforms to display before truncating
 * @returns Formatted platform string
 */
export const formatPlatformDisplay = (
  platformIds: string[] | undefined,
  platforms: any[],
  maxPlatforms = 2,
): string => {
  if (!platformIds?.length) return '';

  const platformNames = platformIds
    .map((platformId) => {
      const platformInfo = platforms.find((p) => p.providerId === 'igdb' && p.providerPlatformId === platformId);
      return platformInfo?.name || platformId;
    })
    .slice(0, maxPlatforms);

  const platformText = platformNames.join(', ');
  const hasMore = platformIds.length > maxPlatforms;

  return `${platformText}${hasMore ? '...' : ''}`;
};

/**
 * Get full platform text for titles using platform IDs and platform store data
 * @param platformIds Array of platform IDs (providerPlatformId values)
 * @param platforms Platform store data
 * @returns Full platform string without truncation
 */
export const getFullPlatformText = (platformIds: string[] | undefined, platforms: any[]): string => {
  if (!platformIds?.length) return '';

  const platformNames = platformIds.map((platformId) => {
    const platformInfo = platforms.find((p) => p.providerId === 'igdb' && p.providerPlatformId === platformId);
    return platformInfo?.name || platformId;
  });

  return platformNames.join(', ');
};
